export default __webpack_public_path__ + "static/media/頂通漫畫.01022bcf.png";